import { RootPage } from '../page';
import $api from '../../api';
import { ChangelogModel, ChangelogsChannelConfig, SegmentModel } from '../../models/Gen/TrackableBaseModels';
import cme from '../../models/ChangelogModelTrackableExtended';
import Pager from '../../components/pager';
import getHashOrDefault from '../../utils/getHashOrDefault';
import languages from '../../utils/languages';
import UrlFilterDescriptor, { areUrlsDefined } from '../../components/descriptors/urlFilterDescriptor';
import RulesDescriptor, { areRulesDefined } from '../../components/descriptors/rulesDescriptor';
import { displayTypeToName } from './utils';
import * as siteConfig from '../../site-config/trackableConfig';
import SegmentationSelector from '../../components/segmentationSelector';
import { listenToPageDirty, resolvePageDirty, beginNoTracking, endNoTracking } from '../../utils/changeTracking';

class ChannelDetailView extends RootPage {
    constructor() {
        super();
        cme();

        this.displayTypeToName = displayTypeToName;

        this.isDirty = ko.observable(false);

        this.deferUpdates = true;
        this.tabsUseHashes = true;

        Pager();
        UrlFilterDescriptor(this);
        RulesDescriptor(this);
        SegmentationSelector(this);

        this.pageInfo = {};
        this.channel = ko.observable(this.getServerSideData('channel'));
        this.channelName = ko.observable(this.channel().name); // todo
        this.channelName.subscribe(() => {
            this.isDirty(true);
        })

        this.announcements = ko.observableArray();
        this.allTours = ko.observable();

        this.setActiveTab(getHashOrDefault('announcements'));

        this.config = ko.observable(new ChangelogsChannelConfig());

        this.triggers = [
            { name: 'Once for all', type: 'onload', icon: 'fas fa-user-plus fa-lg' },
            { name: 'Once for existing users<br />(by Signed Up user prop)', type: 'onload-existing-supat', icon: 'fas fa-user-friends fa-lg' },
            { name: 'Once for existing users<br />(by Created At in PF time)', type: 'onload-existing', icon: 'fas fa-user-friends fa-lg' },
            //{ name: 'Always', type: 'always' },
            /*{ name: 'Manually', type: 'manually', icon: 'fas fa-hand-paper fa-lg' }*/
        ];
        this.selectedTrigger = ko.computed({
            read: () => {
                var serverTrigger = ko.unwrap(this.config().trigger);

                if (!serverTrigger || ko.unwrap(serverTrigger.type) == 'onload') {
                    return this.triggers[0];
                } else {
                    return this.triggers.filter(i => i.type == ko.unwrap(serverTrigger.type))[0];
                }
            },
            write: (val) => {
                var cfg = this.config();

                cfg.trigger(val);
            }
        });

        this.selectedLanguage = ko.observable(window.auth.project.SupportedLanguages[0]);
        this.supportedLanguages = languages.filter(i => window.auth.project.SupportedLanguages.indexOf(i.alpha2) !== -1);

        this.segments = ko.observableArray();

        listenToPageDirty((opt) => {
            console.log('CH', opt.fieldName);
            this.isDirty(true);
        })
    }

    onInit() {
        this.allTours(this.getServerSideData('allTours'));

        ChangelogsChannelConfig.prototype._ModelExtender = function (model, p, pp, mappingOptions) {
            mappingOptions.rules = {
                create: function (options) {
                    console.log('rules');
                    return new siteConfig.RulesDescriptor(options.data);
                }
            };
            mappingOptions.urlFilter = {
                create: function (options) {
                    return new siteConfig.UrlFilterDescriptor(options.data);
                }
            };
        };

        for (const segment of this.getServerSideData('segments')) {
            this.segments.push(new SegmentModel(segment));
        }

        this.config(new ChangelogsChannelConfig(this.getServerSideData('channelConfig')));
    }

    createAnnouncement() {
        window.location.href = `/${window.auth.project.UniqueCode}/announcements/createdraft?channelId=${ko.unwrap(this.channel().id)}`
    }

    //loadConfig() {
    //    $api.changelogs.getChannelConfig({ projectCode: window.auth.project.UniqueCode, id: this.channel().id }, {}, (res) => {
    //        beginNoTracking(this.config());

    //        console.log('A');
    //        const newCfg = new ChangelogsChannelConfig(res);
    //        console.log('B');
    //        beginNoTracking(newCfg);

    //        this.config(newCfg);

    //        if (!this.config().trigger()) {
    //            this.config().trigger(this.triggers[0]);
    //        }

    //        endNoTracking(newCfg);
    //        endNoTracking(this.config()); // redundant but for sure
    //    });
    //}

    saveConfig() {
        this.startSubmitting('saveSettings');
        $api.changelogs.saveChannelConfig({ projectCode: window.auth.project.UniqueCode, id: this.channel().id, name: this.channelName() }, this.config().toJS(), () => {
            this.stopSubmitting('saveSettings');
            this.showToast('Channel settings saved.');
            this.isDirty(false);
            resolvePageDirty();
        });
    }

    deleteChannel() {
        this.confirmStandardDialog('Do you really want to delete this channel?', {
            success: () => {
                this.startSubmitting('delete');

                $api.changelogs.deleteChannel(
                    { projectCode: auth.project.UniqueCode, id: this.channel().id },
                    {},
                    () => {
                        this.stopSubmitting('delete');
                        window.location.href = '/' + auth.project.UniqueCode + '/announcements/overview';
                    }
                );
            }
        });
    }

    bindLocalizableProp(observable) {
        return ko.computed({
            read: () => {
                var val = observable();
                if (!val) {
                    return undefined;
                }

                return ko.unwrap(observable()[this.selectedLanguage()]);
            },
            write: (val) => {
                var curV = observable();

                if (!curV) {
                    curV = {};
                }

                curV[this.selectedLanguage()] = val;

                observable(curV);
            }
        });
    }

    getSomeLocalizedValue(obs) {
        if (obs('en')()) return obs('en') || '<i>No title...</i>';

        for (const lng of this.supportedLanguages) {
            if (obs(lng.alpha2)()) {
                return obs(lng.alpha2) || '<i>No title...</i>';
            }
        }

        return '<i>No title...</i>';
    }

    getSomeLocalizedContentPart(obs, stripHtml) {
        return ko.pureComputed(() => {
            /** @type {string} */
            let val = ko.unwrap(this.getSomeLocalizedValue(obs)) || '';

            if (stripHtml) {
                const d = document.createElement('div');
                d.innerHTML = val;
                val = d.textContent;
            }

            if (val) {
                if (val.length > 60) {
                    return val.substring(0, 60) + '...'
                } else {
                    return val;
                }
            } else {
                return '<i>No text yet...</i>';
            }
        });
    }
}

export default ChannelDetailView;